import AnimationController from '../../assets/js/controllers/animation';
import ResizeController from '../../assets/js/controllers/resize';

import { lodash, splitTextNested, validateParamBoolean } from '../../assets/js/helpers';

export default class ScrollAnimatedHeading {

	static selector = 'animation-heading';

	// class variables

	controllers = {
		resize: null
	};

	coords = {
		container: {
			width: 0
		}
	};

	el = {};

	flags = {
		isLines: true,
		isWords: false		// data-animation-heading-words
	};

	splits = [];

	throttled = {
		renderSplit: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			paragraphs: container.querySelectorAll('p')
		};

		this.flags.isWords = validateParamBoolean(this.el.container, 'data-animation-heading-words', false);
		this.flags.isLines = !this.flags.isWords;

		// limit how frequently text is split (in case screen is being resized)
		this.throttled.renderSplit = lodash.throttle(this.renderSplit.bind(this), 500, { trailing: false });

		this.initialize();
	}

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		document.addEventListener('load', this.#onDocumentLoad);

		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		document.removeEventListener('load', this.#onDocumentLoad);
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onDocumentLoad = () => {
		this.measureAndRender();
	}

	// controller methods

	#onResizeUpdate = () => {
		const lastWidth = this.coords.container.width;
		let isChanged = false;

		this.measure();

		if (lastWidth !== this.coords.container.width) {
			isChanged = true;
		}

		return isChanged;
	}

	#onResizeRender = () => {
		this.throttled.renderSplit();
	}

	// measure

	measure() {
		this.coords.container.width = this.el.container.offsetWidth;
	}

	// render

	renderSplit() {
		for (let i = 0; i < this.splits.length; i++) {
			const split = this.splits[i];
			split.revert();
		}

		this.splits = [];

		// split configuration

		// const splitType = this.el.container.getAttribute('data-animation-heading') || 'lines';

		// mark container as not rendered
		this.el.container.classList.add('is-splitting');
		this.el.container.classList.remove('is-split');

		// complete split

		if (this.el.paragraphs.length) {
			// rich headings can have paragraphs <p>
			for (let i = 0; i < this.el.paragraphs.length; i++) {
				const $paragraph = this.el.paragraphs[i];
				const split = splitTextNested($paragraph, this.flags.isLines, this.flags.isWords);
				this.splits.push(split);
			}
		} else {
			// simple headings are just text, no <p> children
			const split = splitTextNested(this.el.container, this.flags.isLines, this.flags.isWords);
			this.splits.push(split);
		}

		// mark rendered
		AnimationController.one({
			update: () => true,
			render: () => {
				this.el.container.classList.remove('is-splitting');
				this.el.container.classList.add('is-split');
			}
		});
	}

	//

	measureAndRender() {
		this.measure();
		this.renderSplit();
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
